import React, {useState, useEffect} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';

import "./Comment.css";
import arrow from "../../../assets/images/grayarrow.gif";
import {getDifferenceBetweenDates} from "../../../Utils/utils";
import * as actions from "../../../store/actions";

const Comment = (props) => {

    const [upVote, setUpVote] = useState(false);

    const token = useSelector(state => state.auth.token)
    const isAuth = useSelector(state => state.auth.token !== null)
    const userId = useSelector(state => state.auth.userId)

    useEffect(() => {
        if(props.upVoteBy) {
            const vote = props.upVoteBy[userId] === 1
            setUpVote(vote)
        }
    }, [props.upVoteBy, userId])

    const dispatch = useDispatch()

    const onToggleUpVote = (event) => {
        event.preventDefault()
        if (!isAuth) {
            props.history.push({
                pathname: '/auth',
                search: "?goto=" + props.location.pathname.substring(1) + props.location.search
            })
            return;
        }
        dispatch(actions.postCommentToggleUpVote(props.id, props.commentId, props.postId, props.userId, userId, props.points, upVote, token))
        setUpVote(flag => !flag)
    }

    return (
        <tbody key={props.commentId} className="Comment">
        <tr className="info">
            <td title="upvote">
                <div onClick={onToggleUpVote} style={{visibility: !upVote ? "visible" : "hidden"}}>
                    <img src={arrow} alt=""/>
                </div>
            </td>
            <td>
                <Link
                    to={{
                        pathname: "/user",
                        search: "?userId=" + props.userId
                    }}
                >
                    {props.author}
                </Link>
                &nbsp;| {props.points} points |&nbsp;
                {getDifferenceBetweenDates(new Date(props.createdOn), new Date())}
                {upVote ? (
                    <>
                        &nbsp;|&nbsp;
                        <a href={window.location} onClick={onToggleUpVote}>unvote </a>
                    </>
                ) : null}
            </td>
        </tr>
        <tr>
            <td colSpan="1"/>
            <td><span>{props.commentBody}</span></td>
        </tr>
        <tr style={{height: "5px"}}/>
        </tbody>
    )
}

export default withRouter(Comment);